import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import VerticalTabsCustom from '../verticalTabsCustom/verticalTabsCustom';
import VerticalTabs from '../verticalTabs/verticalTabs';
import TextLabel from '../textLabel/textLabel';
import InfoIcon from '../infoIcon/infoIcon';
var CorvidSiteStructure = /*#__PURE__*/function (_React$PureComponent) {
  function CorvidSiteStructure() {
    _classCallCheck(this, CorvidSiteStructure);
    return _callSuper(this, CorvidSiteStructure, arguments);
  }
  _inherits(CorvidSiteStructure, _React$PureComponent);
  return _createClass(CorvidSiteStructure, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        getClassName = _this$props.getClassName,
        dataHook = _this$props.dataHook,
        value = _this$props.value,
        onChange = _this$props.onChange,
        collapsed = _this$props.collapsed,
        topTabs = _this$props.topTabs,
        bottomTabs = _this$props.bottomTabs,
        headerText = _this$props.headerText,
        infoText = _this$props.infoText,
        infoLinkText = _this$props.infoLinkText,
        onLinkClick = _this$props.onLinkClick,
        onBarClick = _this$props.onBarClick,
        children = _this$props.children,
        showOnlyLabels = _this$props.showOnlyLabels;
      var showInfoIcon = Boolean(infoText || infoLinkText);
      var currentValue = collapsed ? null : value;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName('corvid-site-structure')
      }, /*#__PURE__*/React.createElement("div", {
        className: "vertical-tabs",
        "data-hook": "vertical-tabs"
      }, /*#__PURE__*/React.createElement("div", {
        className: "top-tabs"
      }, showOnlyLabels ? /*#__PURE__*/React.createElement(VerticalTabs, {
        value: currentValue,
        onChange: onChange,
        options: topTabs,
        maxWidth: 175,
        showDivider: true
      }) : /*#__PURE__*/React.createElement(VerticalTabsCustom, {
        closed: false,
        value: currentValue,
        onChange: onChange,
        options: topTabs
      })), /*#__PURE__*/React.createElement("div", {
        className: "empty-space",
        "data-hook": "empty-space",
        onClick: onBarClick
      }), /*#__PURE__*/React.createElement("div", {
        className: "bottom-tabs"
      }, showOnlyLabels ? /*#__PURE__*/React.createElement(VerticalTabs, {
        value: currentValue,
        onChange: onChange,
        options: bottomTabs,
        maxWidth: 175,
        showDivider: true
      }) : /*#__PURE__*/React.createElement(VerticalTabsCustom, {
        closed: false,
        value: currentValue,
        onChange: onChange,
        options: bottomTabs
      }))), !collapsed && /*#__PURE__*/React.createElement("div", {
        className: "tab-container",
        "data-hook": "tab-container"
      }, headerText && /*#__PURE__*/React.createElement("div", {
        className: "tab-header",
        "data-hook": "tab-header"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "tab-header-label",
        dataHook: "tab-header-label",
        value: headerText,
        type: "T21"
      }), showInfoIcon && /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: "tab-header-info-icon",
        text: infoText,
        linkText: infoLinkText,
        onLinkClick: onLinkClick
      })), /*#__PURE__*/React.createElement("div", {
        className: "tab-content",
        "data-hook": "tab-content"
      }, children)));
    }
  }]);
}(React.PureComponent);
CorvidSiteStructure.displayName = 'CorvidSiteStructure';
CorvidSiteStructure.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Indicates the current active tab */
  value: PropTypes.string,
  /** Invoked on tab change. Parameters: <ol><li><code>value</code> - the value of the new active tab {string}</li></ol> */
  onChange: PropTypes.func.isRequired,
  /** List of tab headers rendered at the top of the sidebar */
  topTabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    symbol: PropTypes.node.isRequired
  })),
  /** List of tab headers rendered at the bottom of the sidebar */
  bottomTabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    symbol: PropTypes.node.isRequired
  })),
  /** Indicates whether the panel is open (`false`) or closed (`true`) */
  collapsed: PropTypes.bool,
  /** Text content in the header */
  headerText: PropTypes.string.isRequired,
  /** Text content of the info-icon's tooltip */
  infoText: PropTypes.string,
  /** Text content of the link in the info-icon's tooltip */
  infoLinkText: PropTypes.string,
  /** Handles click event of the link in the info-icon's tooltip */
  onLinkClick: PropTypes.func,
  /** Handles click event of the empty part of the bar (where there are no tab header) */
  onBarClick: PropTypes.func,
  /** Set to `true` to show only labels for tab headers instead of icons+labels */
  showOnlyLabels: PropTypes.bool
};
CorvidSiteStructure.defaultProps = {
  topTabs: [],
  bottomTabs: [],
  collapsed: false,
  onBarClick: _.noop,
  showOnlyLabels: false
};
export default compose(CorvidSiteStructure);